export const ACCESS_REQUIREMENT_CODES = Object.freeze({
  PROFILE_REQUIRED: "profile_required",
  EXTRA_CREDITS_REQUIRED: "extra_credits_required",
  SUBSCRIPTION_REQUIRED: "subscription_required",
  STARTER_REQUIRED: "starter_required",
  IMPULSE_REQUIRED: "impulse_required",
  FEATURE_REQUIRED: "feature_required",
});

export const ACCESS_REQUIREMENT_MESSAGES = Object.freeze({
  [ACCESS_REQUIREMENT_CODES.PROFILE_REQUIRED]: "Please sign in to continue.",
  [ACCESS_REQUIREMENT_CODES.EXTRA_CREDITS_REQUIRED]:
    "You need more credits to continue.",
  [ACCESS_REQUIREMENT_CODES.SUBSCRIPTION_REQUIRED]:
    "A subscription is required to continue.",
  [ACCESS_REQUIREMENT_CODES.STARTER_REQUIRED]:
    "A Starter plan is required to continue.",
  [ACCESS_REQUIREMENT_CODES.IMPULSE_REQUIRED]:
    "An Impulse plan is required to continue.",
  [ACCESS_REQUIREMENT_CODES.FEATURE_REQUIRED]:
    "Your current plan does not include this feature.",
});

const accessRequirementCodeList = Object.freeze(
  Object.values(ACCESS_REQUIREMENT_CODES)
);

export function isAccessRequirementError(message) {
  return accessRequirementCodeList.includes(String(message || "").trim());
}

export function humanizeAccessRequirementMessage(message) {
  const normalizedMessage = String(message || "").trim();

  return ACCESS_REQUIREMENT_MESSAGES[normalizedMessage] || normalizedMessage;
}
